<template>
  <div id="ranking">
    <nav-common></nav-common>
    <div class="top-title"><img src="../../../static/images/top-title.png" width="296"></div>
    <div class="main">
      <div class="main-left">
        <div class="switch-box">
          <el-switch
            v-model="currentRanking"
            @change="getranking(currentRanking)"
            active-value="2"
            inactive-value="3"
            active-text="当月榜单"
            inactive-text="历史榜单">
          </el-switch>
        </div>
        <div class="item">
          <span class="icon iconfont icon-1"></span>
          <div class="name">办卡量</div>
        </div>
      </div>
      <div class="main-right sep">
        <div class="top">
          <span>排名</span>
          <span>姓名</span>
          <span>申请量</span>
        </div>
        <ul class="list">
          <li v-for="(card,index) of cardRank">
            <span class="num" v-text="index + 1"></span>
            <span class="name" v-text="card.leading_official"></span>
            <span v-text="card.card_number"></span>
          </li>
          <li v-show="cardRank.length <= 0"><span class="name">暂无数据</span></li>
        </ul>
      </div>
    </div>
    <div class="main">
      <div class="main-left">
        <div class="item">
          <span class="icon iconfont icon-leijishouru"></span>
          <div class="name">贷款量</div>
        </div>
      </div>
      <div class="main-right">
        <div class="top">
          <span>排名</span>
          <span>姓名</span>
          <span>申请量</span>
        </div>
        <ul class="list">
          <li v-for="(loan,index) of loanRank">
            <span class="num" v-text="index + 1"></span>
            <span class="name" v-text="loan.leading_official"></span>
            <span v-text="loan.loan_number"></span>
          </li>
          <li v-show="loanRank.length <= 0"><span class="name">暂无数据</span></li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import NavCommon from '@/components/navtop/navcommon'
export default {
  name: 'Ranking',
  data() {
      return {
        currentRanking: 2,
        cardRank: [],
        loanRank: [],
        agentProfit: [],
        channelProfit: [],
        is_login: true
      }
  },
  created() {
    this.getranking(3);
  },
  methods: {
    hasClass(elem, cls) {
      cls = cls || '';
      if (cls.replace(/\s/g, '').length == 0) return false; //当cls没有参数时，返回false
      return new RegExp(' ' + cls + ' ').test(' ' + elem.className + ' ');
    },
    addClass(ele, cls) {
      if (!hasClass(elem, cls)) {
        ele.className = ele.className == '' ? cls : ele.className + ' ' + cls;
      }
    },
    removeClass(ele, cls) {
      if (hasClass(elem, cls)) {
        var newClass = ' ' + elem.className.replace(/[\t\r\n]/g, '') + ' ';
        while (newClass.indexOf(' ' + cls + ' ') >= 0) {
          newClass = newClass.replace(' ' + cls + ' ', ' ');
        }
        elem.className = newClass.replace(/^\s+|\s+$/g, '');
      }
    },
    getranking(type) {
      let _this = this;
      _this.$http({
        method: 'get',
        url: _this.$api + '/service/agent/statistics/index?type=' + type
      }).then((res) => {
        if(res.data.code == 200) {
          _this.cardRank = res.data.data.card_count;
          _this.loanRank = res.data.data.loan_count;
          _this.agentProfit = res.data.data.agent_profit;
          _this.channelProfit = res.data.data.channel_profit;
        }
      });
    }
  },
  components: {
    NavCommon
  }
}
</script>
<style lang="stylus" scoped>
  #ranking
    background #fff
    .top-title
      width 100%
      height 120px
      line-height 140px
      text-align center
      img
        vertical-align middle
    .main
      position relative
      display flex
      width 1000px
      margin 0 auto 10px auto
      .sep
        padding-bottom 10px
        border-bottom 1px dashed #123e97
      .main-left
        flex 0 0 180px
        margin-right 80px
        .switch-box
          height 90px
          line-height 90px
        .item
          width 100%
          height 136px
          background #f6f6f6
          text-align center
          .icon
            display inline-block
            margin-top 20px
            margin-bottom 5px
            font-size 70px
            color #123e97
      .main-right
        flex 1
        text-align center
        .top
          display flex
          background #fff
          color #000
          width 100%
          height 90px
          line-height 90px
          font-size 20px
          font-weight bold
          span
            flex 1
        .list
          li
            display flex
            height 30px
            line-height 30px
            background #f6f6f6
            &:nth-child(even)
              background #fff
            span
              flex 1
            .num
              color #198ef6
            .name
              color #e99a11
</style>




// WEBPACK FOOTER //
// src/components/ranking/ranking.vue